document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.hero-slide');
    var dots = root.querySelectorAll('.hero-slideshow__dot');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var current = 0;
    var timer = null;

    if (slides.length < 2) return;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.goto, 10));
        restart();
      });
    });

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

    // pausa el autoplay si el mouse está sobre el banner
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    restart();
  });
});
